
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import ckeditor4 from "@/components/CkeditorComponent.vue";

    @Component({
        name: 'measuringDetail',
        components: {ckeditor4}
    })
    export default class Home extends Vue {
        @Prop()
        private paramList !: any;//传入的数据
        @Prop()
        private params !: any; // 测量范围参数名
        visible = true
        form4 = {} as any
        rules = {} as any


        created() {
          this.$set(this.form4, this.params.param1, this.paramList[this.params.param1]);
          this.$set(this.form4, this.params.param2, this.paramList[this.params.param2]);
          this.rules[this.params.param1] = [{required: true, message: '请填写测量范围', trigger: ['change', 'blur']}];
          this.rules[this.params.param2] = [{required: true, message: '请填写不确定度/准确度等级/最大允许误差', trigger: ['change', 'blur']}];
        }

        //关闭
        closeAddSurveyRanges() {
            this.$emit("closeAddSurveyRanges");
        }

        //提交
        submitAddSurveyRanges() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    this.$emit("submitSurveyRangesAdd", this.form4);
                } else {
                    this.$message.warning("未填写完整信息");
                }
            });
        }
    }
